export default __webpack_public_path__ + "static/extreme-d2e17e6f19a022af4decabbaa8367e6f.png";